import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { IInvoiceModel } from 'src/app/shared/models/credential/invoice.model';
import { PersonProfileService } from 'src/app/people/profile/person-profile.service';
import { SubmitApplicationResultModel } from 'src/app/shared/models/application/submitApplicationResultModel';

@Component({
  selector: 'app-application-confirmation',
  templateUrl: './application-confirmation.component.html',
  styleUrls: ['./application-confirmation.component.scss'],
})
export class ApplicationConfirmationComponent implements OnInit {
  @Input()
  previewForm: { confirmation: string };
  isAdded: boolean;
  confirmationMessage: string;
  personInvoiceId: string;
  checkInstructions: string;
  invoice: IInvoiceModel;
  personId: string;
  constructor(private personProfileService: PersonProfileService, router: Router) {
    const state = router.getCurrentNavigation()?.extras?.state;
    if (!state) {
      return; //keep this in constructor. Moving to on-init then router.getCurrentNavigation() return null
    }

    const { personInvoiceId, personId, isAdded, confirmationMessage, checkInstructions } =
      state as SubmitApplicationResultModel & {
        checkInstructions: string;
        confirmationMessage: string;
      };
    this.isAdded = isAdded;
    this.checkInstructions = checkInstructions;
    this.confirmationMessage = confirmationMessage;
    this.personInvoiceId = personInvoiceId;
    this.personId = personId;
  }

  ngOnInit() {
    this.onInit();
  }

  onInit() {
    if (this.previewForm?.confirmation) {
      //form is in preview mode. No further work necessary
      this.confirmationMessage = this.previewForm.confirmation;
      return;
    }
    if (!this.personInvoiceId) {
      return;
    }
    if (this.personId) {
      this.personProfileService
        .getPaymentPaymentConfirmation(this.personId, this.personInvoiceId)
        .then((invoice) => {
          this.invoice = invoice;
        });
    } else {
      console.error(
        'expected personId to be set. Cannot set payment confirmation (if there was one)'
      );
    }
  }
}
